import nProgress from "nprogress";
import { home_overview, home_overview_new } from "../Constants/EndPoint";
import { ACS_ACTIVE_ALARM_FETCH_ERROR, ACS_ACTIVE_ALARM_FETCH_LOAD_MORE, ACS_ACTIVE_ALARM_FETCH_START, ACS_ACTIVE_ALARM_FETCH_SUCCESS } from "../Reducer/AcsActiveAlarmSlice";
import { ALARM_SITE_CODE_FETCH_ERROR, ALARM_SITE_CODE_FETCH_SUCCESS } from "../Reducer/AlarmSiteCodeSlice";
import { DOOR_OFFLINE_FETCH_ERROR, DOOR_OFFLINE_FETCH_MORE_SUCCESS, DOOR_OFFLINE_FETCH_START, DOOR_OFFLINE_FETCH_SUCCESS } from "../Reducer/DoorOfflineSlice";
import { DOOR_FETCH_ERROR, DOOR_FETCH_MORE_SUCCESS, DOOR_FETCH_SUCCESS } from "../Reducer/DoorSlice";
import { LOCK_ALARM_HISTORY_FETCH_ERROR, LOCK_ALARM_HISTORY_FETCH_START, LOCK_ALARM_HISTORY_FETCH_SUCCESS, LOCK_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS } from "../Reducer/LockAlarmHistorySlice";
import { LOCK_ALARM_FETCH_ERROR, LOCK_ALARM_FETCH_SUCCESS, LOCK_ALARM_MASTER_FETCH_SUCCESS } from "../Reducer/LockAlarmListSlice";
import { Notify_FETCH_ERROR, Notify_FETCH_SUCCESS } from "../Reducer/NotifySlice";
import { RECTIFIER_ACTIVE_ALARM_FETCH_LOAD_MORE, RECTIFIER_ACTIVE_ALARM_FETCH_SUCCESS, RECTIFIER_ALARM_COUNT_FETCH_SUCCESS, RECTIFIER_ALARM_FETCH_LOAD_MORE, RECTIFIER_ALARM_FETCH_SUCCESS, RECTIFIER_ALARM_MASTER_FETCH_SUCCESS, RECTIFIER_ALARM_NAV_FETCH_SUCCESS } from "../Reducer/RectifierAlarmSlice";
import { RECTIFIER_COUNT_FETCH_SUCCESS, RECTIFIER_FETCH_ERROR, RECTIFIER_FETCH_LOAD_MORE, RECTIFIER_FETCH_SUCCESS } from "../Reducer/RectifierSlice";
import { RMS_ACTIVE_ALARM_HISTORY_FETCH_SUCCESS, RMS_ACTIVE_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS } from "../Reducer/RmsActiveAlarmHistorySlice";
import { RMS_ACTIVE_ALARM_FETCH_ERROR, RMS_ACTIVE_ALARM_FETCH_LOAD_MORE, RMS_ACTIVE_ALARM_FETCH_START, RMS_ACTIVE_ALARM_FETCH_SUCCESS } from "../Reducer/RmsActiveAlarmSlice";
import { RMS_ALARM_GROUP_FETCH_SUCCESS } from "../Reducer/RmsAlarmGroupSlice";
import { RMS_ALARM_HISTORY_FETCH_ERROR, RMS_ALARM_HISTORY_FETCH_START, RMS_ALARM_HISTORY_FETCH_SUCCESS, RMS_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS, RMS_ALARM_MASTER_FETCH_SUCCESS } from "../Reducer/RmsAlarmHistorySlice";
import { RMS_STATION_FETCH_ERROR, RMS_STATION_FETCH_LOAD_MORE, RMS_STATION_FETCH_SUCCESS } from "../Reducer/RmsStationSlice";
import { RMS_STATUS_FETCH_ERROR, RMS_STATUS_FETCH_LOAD_MORE, RMS_STATUS_FETCH_SUCCESS } from "../Reducer/RmsStatusSlice";
import { TIMELINE_FETCH_SUCCESS } from "../Reducer/TimelineSlice";
import { HOME_FETCH_SUCCESS } from "../Reducer/homeSlice";
import { TENANT_ALARM_COUNT_FETCH_ERROR, TENANT_ALARM_COUNT_FETCH_SUCCESS } from "../Reducer/tenantAlarmCountSlice";
import { TENANT_FETCH_START, TENANT_FETCH_SUCCESS } from "../Reducer/tenantSlice";
import API from "./API";
import axios from 'axios';
import { CLUSTER_FETCH_SUCCESS } from "../Reducer/ClusterSlice";
import { ar } from "date-fns/locale";
import Availability from "../Component/Rms/home/Availability";

const limit = (count) => `page=${count}`;


const Notification = {
    all: (page, dispatch) =>
        API.get(`/v1/oauth/notifications?${limit(20, page)}`).then(response => {
            dispatch(Notify_FETCH_SUCCESS(response.data.data));
        }).catch((error) => {
            dispatch(Notify_FETCH_ERROR());
        }),

    latest: (dispatch) =>
        API.get(`/v1/oauth/notifications`).then(response => {
            dispatch(Notify_FETCH_SUCCESS(response.data.data));
        }).catch((error) => {
            dispatch(Notify_FETCH_ERROR());
        }),

    readAll: () =>
        API.post('/v1/oauth/notification-read-all'),

    allPage: (params = {}) => {
        const qs = new URLSearchParams();
        qs.set('page', params.page ?? 1);
        if (params.per_page) qs.set('per_page', params.per_page);
        if (params.filter) qs.set('filter', params.filter);
        if (params.q) qs.set('q', params.q);
        return API.get(`/v1/oauth/all_notification?${qs.toString()}`);
    },

    markRead: (ids) => {
        const fd = new FormData();
        (ids || []).forEach((id, i) => fd.append(`ids[${i}]`, id));
        return API.post('/v1/oauth/notification-read', fd);
    },

    remove: (ids, all = false) => {
        const fd = new FormData();
        if (all) {
            fd.append('all', 1);
        } else {
            (ids || []).forEach((id, i) => fd.append(`ids[${i}]`, id));
        }
        return API.post('/v1/oauth/notification-delete', fd);
    },
}

const All_RMS = {
    all: (dispatch) =>
        API.get(`/v1/oauth/rms_station?page=1`).then(response => {
            dispatch(RMS_STATION_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(RMS_STATION_FETCH_ERROR());
        }),
    rms_nav: (dispatch) => {
        API.get('/v1/oauth/rms_alarm_nav').then((response) => {
            dispatch(RMS_ALARM_GROUP_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {

        });
    },
    load_more: (dispatch, page) => {
        API.get(`/v1/oauth/rms_station?page=${page}`).then((response) => {
            dispatch(RMS_STATION_FETCH_LOAD_MORE(response.data.data))
        }).catch((error) => {
        });
    },
    export: (array_data) => {
        const qs = new URLSearchParams();
        if (array_data?.site_id) qs.set('site_id', array_data.site_id);
        if (array_data?.easi_site_id) qs.set('easi_site_id', array_data.easi_site_id);
        if (array_data?.cluster_id) qs.set('cluster_id', array_data.cluster_id);
        if (array_data?.zone_id) qs.set('zone_id', array_data.zone_id);
        if (array_data?.tenant) qs.set('tenant', array_data.tenant);
        if (array_data?.type_id) qs.set('type_id', array_data.type_id);
        if (array_data?.alarm_id) qs.set('alarm_id', array_data.alarm_id);
        return API.get(`/v1/oauth/rms_station/export?${qs.toString()}`, {
            responseType: 'blob',
        });
    },

    siteDownHistory: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/site_down_history?site_id=${array_data?.site_id}&tenant_id=${array_data?.tenant_id}&page=${array_data?.page}&is_active=${array_data?.filter_type}`, { signal });
            return response.data;
        } catch (error) {
            return null;
        }
    }


}

const All_RMS_STATUS = {
    all: async (dispatch, array_data) =>
        API.get(`/v1/oauth/all_rms_station?page=${array_data?.page}&tenant_id=${array_data?.tenant_id}&q=${array_data?.site_id}&cluster_id=${array_data?.cluster}&zone_id=${array_data?.zone}&filter_type=${array_data?.filter_type}`).then(response => {
            if (array_data?.lodeMore) {
                dispatch(RMS_STATUS_FETCH_LOAD_MORE(response.data.data))

            } else {

                dispatch(RMS_STATUS_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(RMS_STATUS_FETCH_ERROR());
        }),
    load_more: (dispatch, page) => {
        API.get(`/v1/oauth/all_rms_station?page=${page}`).then((response) => {
            dispatch(RMS_STATUS_FETCH_LOAD_MORE(response.data.data))
        }).catch((error) => {
        });
    },
    export: (array_data) => {
        const qs = new URLSearchParams();
        if (array_data?.site_id) qs.set('q', array_data.site_id);
        if (array_data?.tenant_id) qs.set('tenant_id', array_data.tenant_id);
        if (array_data?.cluster) qs.set('cluster_id', array_data.cluster);
        if (array_data?.zone) qs.set('zone_id', array_data.zone);
        if (array_data?.filter_type) qs.set('filter_type', array_data.filter_type);
        return API.get(`/v1/oauth/all_rms_station/export?${qs.toString()}`, {
            responseType: 'blob',
        });
    },

}



const RMS_ALARM = {
    nav: async (dispatch, signal) =>
        API.get('/v1/oauth/rms_alarm_nav', { signal }).then((response) => {
            dispatch(RMS_ALARM_GROUP_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {

        }),

    rms_alarm_type: async (dispatch, signal) =>
        API.get('/v1/oauth/rms_alarm_master', { signal }).then((response) => {
            dispatch(RMS_ALARM_MASTER_FETCH_SUCCESS(response.data.data.rms_alarms))
        }).catch((error) => {
        }),


    rms_active_alarm: async (dispatch, array_data, signal) => {
        dispatch(RMS_ACTIVE_ALARM_FETCH_START());
        API.get(`/v1/oauth/rms_active_alarm?page=${array_data?.page}&site_id=${array_data?.site_id ?? array_data?.site_code}&from_date=${array_data?.from_date ?? array_data?.start_date}&to_date=${array_data?.to_date ?? array_data?.end_date}&alarmIds=${array_data?.query ?? ''}&cluster=${array_data?.cluster ?? ''}&zone=${array_data?.zone ?? ''}&tenant_id=${array_data?.tenant_id ?? ''}`, { signal }).then((response) => {
            if (array_data?.loadMore) {
                dispatch(RMS_ACTIVE_ALARM_FETCH_LOAD_MORE(response.data.data))
            } else {
                dispatch(RMS_ACTIVE_ALARM_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(RMS_ACTIVE_ALARM_FETCH_ERROR());
        });
    },

    acs_active_alarm: async (dispatch, array_data, signal) => {
        dispatch(ACS_ACTIVE_ALARM_FETCH_START())
        API.get(`/v1/oauth/acs_active_alarm?page=${array_data?.page}&site_id=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&alarm_type=${array_data?.alarm_type ?? ''}`, { signal }).then((response) => {
            if (array_data?.loadMore) {
                dispatch(ACS_ACTIVE_ALARM_FETCH_LOAD_MORE(response.data.data))
            } else {
                dispatch(ACS_ACTIVE_ALARM_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(ACS_ACTIVE_ALARM_FETCH_ERROR());
        })
    },

    rectifier_active_alarm: async (dispatch, array_data, isLoadMore = false) =>
        API.get(`/v1/oauth/dashboard/rectifier_active_alarms?page=${array_data?.page}&q=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&alarm_type=${array_data?.alarm_type}`).then((response) => {

            if (isLoadMore) {
                dispatch(RECTIFIER_ALARM_FETCH_LOAD_MORE(response.data.data))
            } else {
                dispatch(RECTIFIER_ALARM_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
        }),

    rectifier_live_alarm: async (dispatch, array_data, isLoadMore = false) =>
        API.get(`/v1/oauth/dashboard/rectifier_active_alarms?page=${array_data?.page}&q=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&alarm_type=${array_data?.alarm_type}&tenant=${array_data?.tenant_id}`).then((response) => {

            if (isLoadMore) {
                dispatch(RECTIFIER_ACTIVE_ALARM_FETCH_LOAD_MORE(response.data.data))
            } else {
                dispatch(RECTIFIER_ACTIVE_ALARM_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
        }),
    rectifier_live_alarm_export: (array_data) => {
        const qs = new URLSearchParams();
        if (array_data?.site_id) qs.set('q', array_data.site_id);
        if (array_data?.tenant_id) qs.set('tenant', array_data.tenant_id);
        if (array_data?.alarm_type) qs.set('alarm_type', array_data.alarm_type);
        return API.get(`/v1/oauth/dashboard/rectifier_active_alarms/export?${qs.toString()}`, {
            responseType: 'blob',
        });
    },



    rectifier_alarm_nav: async (dispatch) =>
        API.get('/v1/oauth/dashboard/rectifier_alarms_nav').then((response) => {
            dispatch(RECTIFIER_ALARM_NAV_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        }),
    rectifier_alarm_count: async (dispatch, signal) => {
        // console.log('➡️ rectifier_alarm_count START:', new Date().toISOString());

        try {
            const response = await API.get('/v1/oauth/dashboard/get_rectifier_alarm_count', { signal });
            // console.log('✅ rectifier_alarm_count SUCCESS:', new Date().toISOString());
            dispatch(RECTIFIER_ALARM_COUNT_FETCH_SUCCESS(response.data.data));
        } catch (error) {
            // console.error('❌ rectifier_alarm_count ERROR:', new Date().toISOString(), error);
        }
    },

    rectifier_count: async (dispatch, signal) =>
        API.get('/v1/oauth/dashboard/get_rectifier_count', { signal }).then((response) => {
            dispatch(RECTIFIER_COUNT_FETCH_SUCCESS(response.data.data.data))
        }).catch((error) => {
        }),

    timeline: (dispatch) =>
        API.get('/v1/oauth/timeline').then((response) => {
            dispatch(TIMELINE_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        }),

    rms_fetch_alarm: (dispatch, array_data, signal) =>
        API.get(`/v1/oauth/rms_filter_alarm/${array_data.alarm_type}?site_id=${array_data.site_id}&tenant_id=${array_data.tenant_id}&page=${array_data.page}`, { signal }).then((response) => {
            if (array_data.loadMore) {
                dispatch(RMS_ACTIVE_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS(response.data.data))

            } else {

                dispatch(RMS_ACTIVE_ALARM_HISTORY_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            console.error('Error fetching alarm:', error);
        }),

    rms_fetch_alarm_load_more: (dispatch, array_data, signal) =>
        API.get(`/v1/oauth/rms_filter_alarm/${array_data.alarm_type}?site_id=${array_data.site_id}&tenant_id=${array_data.tenant_id}&page=${array_data.page}`, { signal }).then((response) => {
            dispatch(RMS_ACTIVE_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            console.error('Error loading more alarms:', error);
        }),

    rms_alarm_history: (dispatch, alarm_type, site_id) => {
        API.get(`/v1/oauth/rms_alarm_history?query=${alarm_type}&site_code=${site_id}`).then((response) => {
            dispatch(RMS_ALARM_HISTORY_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        });

    },

    rms_alarm_history_new: (dispatch, array_data, signal) => {
        nProgress.start()
        dispatch(RMS_ALARM_HISTORY_FETCH_START()) // Clear previous data
        const alarmQuery = array_data?.query || array_data?.alarm_type || '';
        API.get(`/v1/oauth/rms_alarm_history?page=${array_data?.page}&query=${encodeURIComponent(alarmQuery)}&site_id=${array_data?.site_code ?? ''}&start_date=${array_data?.start_date}&end_date=${array_data?.end_date}&tenant_id=${array_data?.tenant_id}&filter_type=${array_data?.filter_type}&cluster=${array_data?.cluster ?? ''}&zone=${array_data?.zone ?? ''}`, { signal })
            .then((response) => {
                nProgress.done()
                if (array_data?.loadMore) {
                    dispatch(RMS_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS(response.data.data))
                } else {
                    dispatch(RMS_ALARM_HISTORY_FETCH_SUCCESS(response.data.data))

                }

            }).catch((error) => {
                dispatch(RMS_ALARM_HISTORY_FETCH_ERROR())
            });
    },

    refresh_rms_alarm_history: (dispatch, alarm_type, site_id) => {
        API.get(`/v1/oauth/rms_alarm_history?query=${alarm_type}&site_code=${site_id}`).then((response) => {
            dispatch(RMS_ALARM_HISTORY_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        });
    },
    export_active_alarm: (array_data) => {
        const qs = new URLSearchParams();
        if (array_data?.tenant_id) qs.set('tenant', array_data.tenant_id);
        if (array_data?.alarm_type) qs.set('type', array_data.alarm_type);
        if (array_data?.site_id) qs.set('site_id', array_data.site_id);
        if (array_data?.filter_type) qs.set('filter_type', array_data.filter_type);
        if (array_data?.query) qs.set('query', array_data.query);
        return API.get(`/v1/oauth/report/export_active_alarm?${qs.toString()}`, {
            responseType: 'blob',
        });
    },
    export_rms_alarm_history_new: (array_data) => {
        return API.get(`/v1/oauth/report/export_rms_alarm?tenant_id=${array_data?.tenant_id}&site_id=${array_data?.site_code}&start_date=${array_data?.start_date}&end_date=${array_data?.end_date}&alarm_type=${array_data?.alarm_type}&filter_type=${array_data?.filter_type}&query=${array_data?.query ?? ''}&cluster=${array_data?.cluster}&zone=${array_data?.zone}`, {
            responseType: 'blob',
        });
    }

}


const HOME = {
    overview: (dispatch, signal, cluster_id = '') =>
        API.get(`${home_overview_new}?cluster_id=${cluster_id ?? ''}`, { signal }).then((response) => {
            dispatch(HOME_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            if (error?.response?.status == 401 && error?.response?.statusText == "Unauthorized") {
                localStorage.clear();
                window.location.href = '/';
            }
        }),
    get_rms_tenants: (search) =>
        API.get(`/v1/oauth/rms_tenants?q=${search ?? ''}`).then((response) => {
            return response.data.data;
        }).catch((error) => {
            console.error('Error fetching RMS tenants:', error);
        }),

    sync_tenants: (dispatch) =>
        API.get('/v1/oauth/tenants')
            .then((response) => {
                dispatch(TENANT_FETCH_SUCCESS(response.data.data))
            }).catch((error) => {
            }),

    sync_equipment: (dispatch) =>
        API.get('/v1/oauth/home_equipment_disconnected')
            .then((response) => {

            }).catch((error) => {
            }),

    TENANT_ALARM: (dispatch, signal, cluster_id = '') =>
        API.get(`/v1/oauth/dashboard/tenant_wise_alarms?cluster_id=${cluster_id ?? ''}`, { signal })
            .then((response) => {
                dispatch(TENANT_ALARM_COUNT_FETCH_SUCCESS(response.data.data))
            }).catch((error) => {
                TENANT_ALARM_COUNT_FETCH_ERROR();
            }),
    Cluster: (dispatch) =>
        API.get(`/v1/oauth/clusters`)
            .then(res => {
                dispatch(CLUSTER_FETCH_SUCCESS(res.data.data))
            })
}

const ACS_ALARM = {
    acs_alarm_nav: (dispatch, signal) => {
        API.get(`/v1/oauth/lock_alarm_nav`, { signal }).then((response) => {
            dispatch(LOCK_ALARM_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(LOCK_ALARM_FETCH_ERROR(error))
        });
    },
    lock_alarm_history: async (dispatch, array_data, signal) => {
        dispatch(LOCK_ALARM_HISTORY_FETCH_START()) // Clear previous data
        API.get(`/v1/oauth/lock_alarm_history?page=${array_data?.page}&query=${array_data?.query ?? ''}&site_code=${array_data?.site_code ?? ''}&start_date=${array_data?.start_date ?? ''}&end_date=${array_data?.end_date ?? ''}`, { signal }).then((response) => {
            if (array_data?.loadMore) {
                dispatch(LOCK_ALARM_HISTORY_LOAD_MORE_FETCH_SUCCESS(response.data.data))
            } else {
                dispatch(LOCK_ALARM_HISTORY_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(LOCK_ALARM_HISTORY_FETCH_ERROR(error))
        });
    },
    acs_active_alarm: async (dispatch, array_data, signal) => {
        dispatch(ACS_ACTIVE_ALARM_FETCH_START())
        API.get(`/v1/oauth/acs_active_alarm?page=${array_data?.page}&site_id=${array_data?.site_id ?? ''}&from_date=${array_data?.from_date ?? array_data?.start_date ?? ''}&to_date=${array_data?.to_date ?? array_data?.end_date ?? ''}&alarmIds=${array_data?.query ?? ''}&query=${array_data?.query ?? ''}&cluster=${array_data?.cluster ?? ''}&zone=${array_data?.zone ?? ''}&tenant_id=${array_data?.tenant_id ?? ''}`, { signal }).then((response) => {
            if (array_data?.loadMore) {
                dispatch(ACS_ACTIVE_ALARM_FETCH_LOAD_MORE(response.data.data))
            } else {
                dispatch(ACS_ACTIVE_ALARM_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(ACS_ACTIVE_ALARM_FETCH_ERROR());
        })
    },
    export_active_alarm: (array_data, signal) => {
        return API.get(`/v1/oauth/report/export_acs_active_alarm?&site_id=${array_data?.site_id}&from_date=${array_data?.from_date ?? array_data?.start_date}&to_date=${array_data?.to_date ?? array_data?.end_date}&alarmIds=${array_data?.query ?? ''}&query=${array_data?.query ?? ''}&cluster=${array_data?.cluster ?? ''}&zone=${array_data?.zone ?? ''}&tenant_id=${array_data?.tenant_id ?? ''}&export_type=${array_data?.export_type}&alarm_type=${array_data?.alarm_type ?? ''}`, {
            responseType: 'blob',
            signal
        });
    },
    export_acs_alarm: (array_data) => {
        return API.get(`/v1/oauth/export_lock_alarm?&site_id=${array_data?.site_id}&from_date=${array_data?.from_date ?? array_data?.start_date}&to_date=${array_data?.to_date ?? array_data?.end_date}&alarmIds=${array_data?.query}&query=${array_data?.query ?? ''}&cluster=${array_data?.cluster ?? ''}&zone=${array_data?.zone ?? ''}&tenant_id=${array_data?.tenant_id ?? ''}&export_type=2`, {
            responseType: 'blob',
        });
    },
    lock_alarm_master: (dispatch) => {
        API.get(`/v1/oauth/lock_alarm_master`).then((response) => {
            dispatch(LOCK_ALARM_MASTER_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        });
    },

}

const All_SITE = {
    all_door_load: (dispatch, page) => {
        API.get(`/v1/oauth/all_door?page=${page}`).then((response) => {
            dispatch(DOOR_FETCH_MORE_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(DOOR_FETCH_ERROR(error))
        });
    },
    searchSite: (dispatch, site_code) => {
        API.get('/v1/oauth/all_door?site_id=' + site_code).then((response) => {
            dispatch(DOOR_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(DOOR_FETCH_ERROR(error))
        });
    },
    syncData: (dispatch) => {
        API.get('/v1/oauth/all_door').then((response) => {
            dispatch(DOOR_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(DOOR_FETCH_ERROR(error))
        });
    },
    alarm_sites: (dispatch) => {
        API.get('/v1/oauth/alarm_sites').then((response) => {
            dispatch(ALARM_SITE_CODE_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            dispatch(ALARM_SITE_CODE_FETCH_ERROR(error))
        });
    },
    acs_sites: (dispatch, array_data, loadMore = false) => {
        API.get(`/v1/oauth/all_door?page=${array_data?.page}&site_id=${array_data?.site_id}&tenant_id=${array_data?.tenant_id}`).then((response) => {
            if (loadMore) {
                dispatch(DOOR_FETCH_MORE_SUCCESS(response.data.data))
            } else {
                dispatch(DOOR_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(DOOR_FETCH_ERROR(error))
        });
    },
    offline_sites: (dispatch, array_data, loadMore = false) => {
        dispatch(DOOR_OFFLINE_FETCH_START())
        API.get(`/v1/oauth/offline_sites?page=${array_data?.page}&site_id=${array_data?.site_id}&hours_type=${array_data?.hours_type}`).then((response) => {
            if (loadMore) {
                dispatch(DOOR_OFFLINE_FETCH_MORE_SUCCESS(response.data.data))
            } else {
                dispatch(DOOR_OFFLINE_FETCH_SUCCESS(response.data.data))
            }

        }).catch((error) => {
            dispatch(DOOR_OFFLINE_FETCH_ERROR(error))
        });
    },
}

let cancelTokenSource = null;
const RECTIFIER = {
    get_rectifier: (dispatch, array_data, loadMore = false) => {
        // Cancel previous request
        if (cancelTokenSource) {
            cancelTokenSource.cancel("Canceled duplicate request");
        }

        cancelTokenSource = axios.CancelToken.source();

        API.get(`/v1/oauth/rectifier_monitoring`, {
            params: {
                page: array_data?.page,
                site_id: array_data?.site_id,
                tenant_id: array_data?.tenant_id,
                brand_id: array_data?.brand_id
            },
            cancelToken: cancelTokenSource.token
        })
            .then((response) => {
                if (loadMore) {
                    dispatch(RECTIFIER_FETCH_LOAD_MORE(response.data.data));
                } else {
                    dispatch(RECTIFIER_FETCH_SUCCESS(response.data.data));
                }
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    console.log("Duplicate request canceled:", error.message);
                } else {
                    dispatch(RECTIFIER_FETCH_ERROR(error));
                }
            });
    },
    export: (array_data) => {
        const qs = new URLSearchParams();
        if (array_data?.site_id) qs.set('site_id', array_data.site_id);
        if (array_data?.tenant_id) qs.set('tenant_id', array_data.tenant_id);
        if (array_data?.brand_id) qs.set('brand_id', array_data.brand_id);
        return API.get(`/v1/oauth/rectifier_monitoring/export?${qs.toString()}`, {
            responseType: 'blob',
        });
    },
    export_active_alarm: (array_data) => {
        return API.get(`/v1/oauth/report/export_rectifier_active_alarm?tenant_id=${array_data?.tenant_id}&alarm_type=${array_data?.alarm_type}&site_id=${array_data?.site_id}&export_type=1`, {
            responseType: 'blob',
        });
    },
    alarm_master: (dispatch) => {
        API.get(`/v1/oauth/rectifier_alarm_master`).then((response) => {
            dispatch(RECTIFIER_ALARM_MASTER_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
        });
    },
}

const SITE_DASHBOARD = {

    /**
     * @param {import('../TypeScript/AgentTypeScript').RectifierOverviewParams['site_id']} site_id
     * @param {import('../TypeScript/AgentTypeScript').RectifierOverviewParams['rectifier_sl_no']} rectifier_sl_no
     * @param {import('../TypeScript/AgentTypeScript').RectifierOverviewParams['signal']} [signal]
     * @returns {Promise<import('../TypeScript/AgentTypeScript').RectifierOverviewResponse | null>}
     */
    rectifier_overview: async (site_id, rectifier_sl_no, signal) => {
        try {
            const response = await API.get(`/v1/oauth/rectifier_app?site_id=${site_id}&sl_no=${rectifier_sl_no}`, { signal });
            return response.data;
        } catch (error) {
            return null;
        }
    },

    /**
     * @param {import('../TypeScript/AgentTypeScript').SiteIdFetchParams['site_id']} array_data
     * @param {import('../TypeScript/AgentTypeScript').SiteIdFetchParams['signal']} [signal]
     * @returns {Promise<import('../TypeScript/AgentTypeScript').SiteIdFetchResponse>}
     */
    site_id_fetch: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/site_wise_tenants?site_id=${array_data}`, { signal });
            return response.data;
        } catch (error) {
            return error;
        }
    },
    dc_avg_kw_hourly: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/dc_avg_kw_hourly?site_id=${array_data?.site_id}&date=${array_data?.date}&tenant_id=${array_data?.tenant_id}&to_date=${array_data?.to_date ?? array_data?.date}`, { signal });
            return response.data;
        } catch (error) {
            return null;
        }
    },
    dc_availability: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/dc_availability?site_id=${array_data?.site_id}&from_date=${array_data?.date}&tenant_id=${array_data?.tenant_id}&to_date=${array_data?.to_date ?? array_data?.date}`, { signal });
            return response.data;
        } catch (error) {
            // console.error(error);
            return null;
        }
    },
    dc_tenant_setting: async (site_id, tenant_id) => {
        try {
            const response = await API.get(`/v1/oauth/dc_tenant_setting?site_id=${site_id}&tenant_id=${tenant_id}`);
            return response.data;
        } catch (error) {
            return error?.response?.data ?? null;
        }
    },
    save_dc_tenant_setting: async (array_data) => {
        try {
            const response = await API.post(`/v1/oauth/dc_tenant_setting`, array_data);
            return response.data;
        } catch (error) {
            return error?.response?.data ?? null;
        }
    },
    dc_voltage: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/dc_voltage?site_id=${array_data?.site_id}&from_date=${array_data?.date}&tenant_id=${array_data?.tenant_id}&to_date=${array_data?.to_date ?? array_data?.date}`, { signal });
            return response.data;
        } catch (error) {
            //  console.error(error);
            return error;
        }
    },

    site_alarm_status: async (site_id) => {
        try {
            const response = await API.get(`/v1/oauth/site_alarm_status?site_id=${site_id}`);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    site_info: async (site_id, signal) => {
        try {
            const response = await API.get(`/v1/oauth/site/${site_id}`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    },
    site_temp_last_hour: async (rms_id, signal) => {
        try {
            const response = await API.get(`/v1/oauth/stations/${rms_id}/temperature/last-hour`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    },
    site_rms_alarm_history: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/site_rms_alarm?page=${array_data?.page}&site_id=${array_data?.site_id}&start_date=${array_data?.start_date}&end_date=${array_data?.end_date}&tenant_id=${array_data?.tenant_id}&alarm_type=${array_data?.alarm_type}&filter_type=${array_data?.filter_type}&query=${array_data?.query}`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    },
    all_sites: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/all_sites?site_id=${array_data?.site_id ?? ''}`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    }
}

const MANAGEMENT_DASHBOARD = {
    availability: async (array_data, signal) => {
        try {
            const response = await API.get(`/v1/oauth/dashboard/availability?start_date=${array_data?.from_date}&end_date=${array_data?.to_date}&tenant_id=${array_data?.tenant_id ?? ''}`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    },
    power_status: async () => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/power_status/rms`);
            return response;
        } catch (error) {
            return error;
        }
    },
    acs_power_status: async () => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/power_status/acs`);
            return response;
        } catch (error) {
            return error;
        }
    },
    temperature_range: async (signal) => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/temperature_range`, { signal });
            return response;
        } catch (error) {
            return error;
        }
    },
    power_availability: async (array_data) => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/power_availability?site_id=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&type=${array_data?.filter_type}`);
            return response;
        } catch (error) {
            return error;
        }
    },
    power_slab: async (array_data) => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/power_slab?site_id=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&type=${array_data?.filter_type}`);
            return response;
        } catch (error) {
            return error;
        }
    },
    alarm_frequency: async (array_data) => {
        try {
            const response = await API.get(`/v1/oauth/management_dashboard/mains-fail-frequency?site_id=${array_data?.site_id}&from_date=${array_data?.from_date}&to_date=${array_data?.to_date}&type=${array_data?.filter_type}&alarm_id=${array_data?.alarm_id}&metric_type=${array_data?.metric}`);
            return response;
        } catch (error) {
            return error;
        }
    },
}

export default {
    MANAGEMENT_DASHBOARD,
    Notification,
    All_RMS,
    RMS_ALARM,
    HOME,
    All_SITE,
    All_RMS_STATUS,
    ACS_ALARM,
    RECTIFIER,
    SITE_DASHBOARD
};